import { Checkbox, FormControlLabel } from "@material-ui/core";

export function CheckBoxField({
	label = "",
	onChange = (e: any) => {},
	value = false,
	...rest
}) {
	return (
		<FormControlLabel
			control={<Checkbox onChange={onChange} checked={value} />}
			label={label}
			{...rest}
		/>
	);
}
